export default __webpack_public_path__ + "static/media/community.1f7b4530.png";